/** Shared badge-collection pill — persists across gallery ↔ profile select/clear. */
let currentGroup = 'all';
const listeners = new Set<() => void>();

export const getBadgeCollectionGroup = (): string => currentGroup;

export const setBadgeCollectionGroup = (group: string): void => {
  if (currentGroup === group) return;
  currentGroup = group;
  listeners.forEach((listener) => listener());
};

export const subscribeBadgeCollectionGroup = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
